.domain-select {
    width: 269px;
}
